import { IHostImage } from "./Interfaces/IHostData";

const IMAGE_SIZES = [40, 60, 140, 160, 320, 640, 1024] as const;

export function buildSrcset(urls: IHostImage["urls"]): string {
    return IMAGE_SIZES
        .filter(s => urls[s])
        .map(s => `${urls[s]} ${s}w`)
        .join(", ");
}

export function getBestSrc(urls: IHostImage["urls"]): string | null {
    for (const s of [...IMAGE_SIZES].reverse()) {
        if (urls[s]) return urls[s]!;
    }
    return null;
}
